import { getNames, registerLocale } from 'i18n-iso-countries'
import { useTranslation } from 'next-i18next'
import * as React from 'react'
import {
	type ComponentProps,
	type ComponentPropsWithoutRef,
	type ComponentRef,
	useMemo,
} from 'react'

import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '~/components/ui/select'

registerLocale(require('i18n-iso-countries/langs/fr.json'))
registerLocale(require('i18n-iso-countries/langs/en.json'))

type Ref = ComponentRef<typeof Select>
type CountrySelectProps = ComponentPropsWithoutRef<typeof Select> & {
	className?: ComponentProps<typeof SelectTrigger>['className']
}

export const CountrySelect = React.forwardRef<Ref, CountrySelectProps>(
	({ className, ...props }, ref) => {
		const { i18n } = useTranslation()

		const options = useMemo(() => {
			const countries = getNames(i18n.language)

			return Object.entries(countries)
				.sort(([, nameA], [, nameB]) => nameA.localeCompare(nameB))
				.map(([value, label]) => ({ label, value }))
		}, [i18n.language])

		return (
			<Select {...props}>
				<SelectTrigger
					ref={ref}
					className={className}
				>
					<SelectValue />
				</SelectTrigger>

				<SelectContent>
					{options.map((option, i) => (
						<SelectItem
							key={option.label}
							value={option.value}
						>
							{option.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		)
	},
)

CountrySelect.displayName = 'CountrySelect'
